<template>
  <div class="w-100 overflow-hidden overflow-x-scroll recent-sales-container">
    <div v-if="!loaded" class="p-4 rounded border bg-light"><loading-spinner class="recent-sale" /></div>
    <div v-else class="recent-sale">
      <order-card v-for="order in orders" :key="order.order_id" :order="order" class="d-inline-block me-2" />

      <order-card v-if="loaded && orders.length === 0" text="No recent orders in the past 7 days" class="d-inline-block me-2" />

      <order-card v-for="i in placeholderCount" :key="'placeholder-' + i" class="d-inline-block me-2" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import OrderCard from "@/app/components/orders/OrderCard.vue";
import LoadingSpinner from "@/app/components/Utils/LoadingSpinner.vue";

const loaded = ref(false);
const orders = ref([]);
const placeholderCount = computed(() => {
  const shown = orders.value.length || (loaded.value ? 1 : 0); // "no orders" card counts as 1
  return Math.max(3 - shown, 0);
});
const store = useStore();

store.dispatch("eshop/getRecentOrders", {days: 7}) // week
  .then(ords => orders.value = ords.filter(o => o.order_status==='Completed'))
  .catch(error => console.log(error))
  .finally(() => (loaded.value = true));
</script>

<style lang="scss" scoped>
.recent-sales-container {
  height: 120px;
  > .recent-sale {
    white-space: nowrap;
    transform:scale(0.8);
    transform-origin:top left;
  }
}
@media (min-width: 768px) {
  .recent-sales-container {
    height: 100px;
    .order-card {vertical-align: top;}
  }
}
</style>
